<template>
  <div>
    <v-btn color="secondary" class="ma-2" @click.native.stop.prevent="toggleModal" id="missionCompletionModal">
      Finished
    </v-btn>
    <v-dialog v-model="isModalOpen" max-width="630px" id="missionCompletionModal" persistent>
      <v-toolbar dark color="primary" class="d-flex justify-center align-center">
        <v-toolbar-title class="body-heading-small">Confirm Quest Submission</v-toolbar-title>
      </v-toolbar>
      <v-card class="modal-content-container">
        <v-card-title class="d-flex justify-center">
          <span class="body-heading-small ma-8">
            Did you finish your quest? After you confirm submission, your parents will verify your submission, and you will get points after that.
          </span>
        </v-card-title>
        <v-card-text>
          <v-form @submit.prevent="completeMission">
            <v-row class="px-3 justify-space-between">
              <v-btn color="secondary" class="modal-btn" type="submit">Confirm </v-btn>
              <v-btn color="secondary" class="modal-btn" outlined @click="toggleModal">Cancel</v-btn>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: "CompleteMissionModal",
    data() {
      return {
        isModalOpen: false,
      };
    },
    props: {
      missionId: {
        type: [String, Number],
        required: true,
      },
    },
    methods: {
      toggleModal() {
        this.isModalOpen = !this.isModalOpen;
      },

      completeMission() {
        this.$store.commit("setLoadingStatus", true);

        this.$http
          .put(`/missions/${this.missionId}`, { mission: { complete: true } })
          .then((response) => this.completeSuccess(response))
          .catch((error) => this.completeFail(error));
      },

      completeSuccess(response) {
        this.$store.commit("setError", {
          message: "Yay! Quest marked as complete! After your parent approves it your points will be deposited!",
          type: "success",
        });

        this.$store.commit("toggleMissionCompletion", this.missionId);
        this.isModalOpen = false;
        this.$store.commit("setLoadingStatus", false);
      },

      completeFail(error) {
        console.log(error);
        this.$store.commit("setError", {
          message: "Opps, looks like something went wrong, please try again later.",
          type: "error",
        });

        this.isModalOpen = false;
        this.$store.commit("setLoadingStatus", false);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Mission/CompleteMissionModal.vue